import { render } from "./WorkFilter2.vue?vue&type=template&id=b89ec7aa&scoped=true"
import script from "./WorkFilter2.vue?vue&type=script&lang=js"
export * from "./WorkFilter2.vue?vue&type=script&lang=js"

import "./WorkFilter2.vue?vue&type=style&index=0&id=b89ec7aa&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89ec7aa"]])

export default __exports__